export async function CountUnreadSugeriments() {
    const url = `${process.env.REACT_APP_API_URL}:8061/usuaris/sugeriments/count`;

    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            }
        });

        if (response.status !== 200) return 0;
        const raw = await response.json();

        // Robust parsing
        if (typeof raw === 'number') return raw;
        if (raw && raw.json && typeof raw.json === 'number') return raw.json; // Direct number in json property
        if (raw && raw.json && typeof raw.json !== 'number') return JSON.parse(raw.json); // Stringified number
        if (raw && raw.count) return raw.count;
        return 0;
    } catch (e) {
        console.error("CountUnreadSugeriments error:", e);
        return 0;
    }
}
